import { fetcher, useAuthFetch } from "matsuri-hooks"
import { Lease, LeaseContractType } from "../domain/lease"
import { m2mCore_v1 } from "../endpoints/m2m-core.v1"

export type CreateLeaseInput = Omit<Lease, "id">

export const requestCreateLease = (token: string, input: CreateLeaseInput) => {
    return fetcher(m2mCore_v1.createLease(), {
        method: "POST",
        token,
        body: JSON.stringify(input)
    })
}

export type UpdateLeaseInput = Omit<Lease, "id">

export const useLease = (token: string, id: string) => {
    return useAuthFetch<Lease>(token, m2mCore_v1.findLeaseById({ id }), {})
}

export const requestUpdateLease = (
    token: string,
    id: string,
    input: UpdateLeaseInput
) => {
    return fetcher(m2mCore_v1.updateLease({ id }), {
        body: JSON.stringify(input),
        method: "PUT",
        token
    })
}

export const requestDeleteLease = (token: string, id: string) => {
    return fetcher(m2mCore_v1.deleteLease({ id }), {
        method: "DELETE",
        token
    })
}

export const useLeaseNeedAction = (token: string) => {
    return useAuthFetch<{ data: Lease[] }>(
        token,
        m2mCore_v1.findNeedActionLeases(),
        {}
    )
}

export const requestReadLeaseNotification = (token: string, id: string) => {
    return fetcher(m2mCore_v1.readLeaseNotification({ id }), {
        method: "POST",
        token
    })
}

export interface ExportLeaseDetailsRow {
    id: string
    roomTypeName: string
    roomTypeId: string
    listingId: string
    listingName: string
    owners: {
        id: string
        companyId: string
        name: string
        operationType: string
    }
    checkin: string
    checkout: string
    contractType: LeaseContractType
    contractStartDate: string
    contractEndDate: string
    rent: number
    contractSpanFixed: boolean
}

export const requestExportLeaseDetails = (
    token: string,
    input: { startDate: string; endDate: string }
) => {
    return fetcher<{ leaseDetails: ExportLeaseDetailsRow[] }>(
        m2mCore_v1.exportLeaseDetails(),
        {
            method: "POST",
            token,
            body: JSON.stringify(input)
        }
    )
}
